import "#/legacy/namespaces.js";
DoctorFinder.Models.Result = class Result extends Backbone.Model {
  constructor() {
    super(...arguments);
    this.parse = this.parse.bind(this);
  }

  defaults() {
    return {
      video_url: null,
      badge: null,
      awards: [],
      provider_visit_type: null,
      distance: null,
      appointment_slots: null,
    };
  }

  parse(response) {
    this.set("appointment_slots", response.appointment_slots); // Clear slots if we parse the data and no slots are given

    return response;
  }
};
DoctorFinder.Models.Result.prototype.idAttribute = "resultGUID";
